import { render, staticRenderFns } from "./SearchQueryFilter.vue?vue&type=template&id=97479790&scoped=true&"
import script from "./SearchQueryFilter.vue?vue&type=script&lang=js&"
export * from "./SearchQueryFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97479790",
  null
  
)

export default component.exports